export default function slugo(input: string) {
  return input
    ?.trim()
    .toLowerCase()
    .replace(/(\s|\.|,)/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
}
